export let life = {
  // 添加回显
  async mounted() {
    if (this.userOrg) {
      // 用户模式
      await this.methods('getOrgByUser');
    } else {
      // 列出所有公司
      await this.methods('getAllCompany');
    }
    // 需要将输入的目标值转换为列表中的对象，提供回显
    this.methods('initModelValue');
  },
};
export let event = {};
export let watch = {
};
